import moment from 'moment';

export let operations = [
	{ id:'==',label:'equals' },
	{ id:'>=',label:'greaterThanOrEqual' },
	{ id:'>',label:'greaterThan' },
	{ id:'<=',label:'lessThanOrEqual' },
	{ id:'<',label:'lessThan' },
	{ id:'!=',label:'notEqual' },
	{ id:'a < x < b',label:'inRangeExclusive',requiredInputCount:2 },
	{ id:'a <= x <= b',label:'inRangeInclusive',requiredInputCount:2 },
];

import objGet from '../objGet';

export function filterFactory(columnDef, op, ...compValues) {
	let compValue;
	let valueGetter;
	if (columnDef.comparableValueGetter)
		valueGetter = columnDef.comparableValueGetter;
	else if (columnDef.valueGetter)
		valueGetter = columnDef.valueGetter;
	else
		valueGetter = (item) => objGet(item,columnDef.field);

	let compString = (value) => moment(value, columnDef.dateFormat).toISOString();

	switch (op) {
	case '>=':
		compValue = compValues[0];
		return (item) => valueGetter(item) >= compString(compValue);
	case '>':
		compValue = compValues[0];
		return (item) => valueGetter(item) > compString(compValue);
	case '<=':
		compValue = compValues[0];
		return (item) => valueGetter(item) <= compString(compValue);
	case '<':
		compValue = compValues[0];
		return (item) => valueGetter(item) <= compString(compValue);
	case '==':
		compValue = compValues[0];
		return (item) => valueGetter(item) === compString(compValue);
	case '!=':
		compValue = compValues[0];
		return (item) => valueGetter(item) !== compString(compValue);
	case 'a < x < b':
		compValues.sort((a,b) => a < b ? -1 : 1);
		return (item) => {
			let val = valueGetter(item);
			return val > compString(compValues[0]) && val < compString(compValues[1]);
		};
	case 'a <= x <= b':
		compValues.sort((a,b) => a < b ? -1 : 1);
		return (item) => {
			let val = valueGetter(item);
			return val >= compString(compValues[0]) && val <= compString(compValues[1]);
		};
	default:
		throw new Error(`Unknown operation: ${  op}`);
	}
}